export default function (value, digits = 2) {
  if (!value) return ''
  const FORMATTER = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits
  })
  return FORMATTER.format(Number(value).toFixed(2))
}
